export function Starfield() {
  return (
    <div className="starfield" aria-hidden="true">
      {Array.from({ length: 22 }, (_, index) => (
        <span key={index} style={{ '--star': index }} />
      ))}
    </div>
  )
}
